<ng-container *transloco="let t; read: 'carousel-multi'">
  <div class="header">
    <div class="title-and-controls">
      <div [ngClass]="titleFontClass()">
        {{ title() }}
      </div>

      @if (!hideControls()) {
        <div class="controls">
          <button
            accredible-button-icon
            size="small"
            color="natural"
            icon="chevron-left"
            [attr.aria-label]="t('aria_prev')"
            [attr.data-cy]="'btn-prev-carousel' + dataCy() ? '-' + dataCy() : ''"
            [iconSize]="'8px'"
            [disabled]="isBeginning()"
            (click)="previous()"></button>

          <button
            accredible-button-icon
            size="small"
            color="natural"
            icon="chevron-right"
            [attr.aria-label]="t('aria_next')"
            [attr.data-cy]="'btn-next-carousel' + dataCy() ? '-' + dataCy() : ''"
            [iconSize]="'8px'"
            [disabled]="isEnd()"
            (click)="next()"></button>
        </div>
      }
    </div>

    @if (subtitle()) {
      <div class="subtitle">
        {{ subtitle() }}
      </div>
    }
  </div>

  @if (carouselItems().length) {
    <accredible-base-carousel [options]="options()">
      @for (carouselItem of carouselItems(); track carouselItem.data()) {
        <accredible-carousel-item>
          <ng-template
            *ngTemplateOutlet="
              carouselItem.data()?.template;
              context: { $implicit: carouselItem.data()?.slideData }
            " />
        </accredible-carousel-item>
      }
    </accredible-base-carousel>
  } @else {
    <ng-content select="carouselMultiNoResults" />
  }
</ng-container>
